import React, { useMemo } from "react";
import { useGetBillingAmountQuery } from "app/store/billingAmount/api/billingAmountApi";

import { useDispatch } from "react-redux";
import { billingAmountRow, getBillingCodes } from "utils/billingAmount";
import EditIcon from "@mui/icons-material/Edit";

import { Tooltip } from "@mui/material";
import { selectBillingAmount } from "app/store/billingAmount/slice/billingAmountSlice";

const useBillingAmountTable = () => {
  const { data, isLoading, isFetching } = useGetBillingAmountQuery();

  const billingCodes = getBillingCodes(
    data?.flatMap((item) => item.billing) || []
  );

  const rpmBillingCodes = getBillingCodes(
    data?.flatMap((item) => item.rpmBilling) || []
  );

  const dispatch = useDispatch();

  const columns = useMemo(
    () => [
      {
        header: "Account",
        accessorKey: "name",
        size: 300,
        accessorFn: (rowData) => rowData?.name,
      },
      ...billingCodes.map((code) => ({
        header: code,
        accessorKey: `billing-${code}`,
        size: 80,
        enableSorting: false,
        accessorFn: (rowData) => billingAmountRow(rowData?.billing, code),
      })),
      ...rpmBillingCodes.map((code) => ({
        header: code,
        accessorKey: `rpm-billing-${code}`,
        size: 80,
        enableSorting: false,
        accessorFn: (rowData) => billingAmountRow(rowData?.rpmBilling, code),
      })),
      {
        header: "Actions",
        accessorKey: "actions",
        enableSorting: false,
        size: 68,
        accessorFn: (rowData) => {
          return (
            <div className="action-buttons">
              <Tooltip header={"Edit"}>
                <EditIcon
                  className="action-buttons__edit"
                  onClick={() => dispatch(selectBillingAmount(rowData))}
                  data-action="edit-billing-amount-icon"
                />
              </Tooltip>
            </div>
          );
        },
      },
    ],
    [billingCodes, rpmBillingCodes]
  );

  return { columns, data, isLoading, isFetching };
};

export default useBillingAmountTable;
